export default "__VITE_ASSET__DTs1tWdc__"